<template>
  <ResultForm :data="data" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import ResultForm from "./ResultForm.vue"
import moment from "moment"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      resultData: null,
      lotto: {
        lotto_id: null,
        lotto_type: this.$route.params.lottoType,
        lotto_date: moment().format("YYYY-MM-DD"),
        round: 'r2',
        show_result: moment().format("YYYY-MM-DD"),
        results: {
          prize_1st: '',
          prize_2nd: ''
        }
      }
    }
  },
  computed: {
    data() {
      return this.lotto
    }
  },
  methods: {
    loadResult() {
      LottoService.getResult({
        lottoType: this.$route.params.lottoType,
        lottoId: this.$route.params.resultId
      }).then((response) => {
        if (response.status === 'success') {
          this.resultData = response.data
          this.lotto.lotto_id = this.resultData.lotto_id
          this.lotto.lotto_type = this.resultData.lotto_type
          this.lotto.lotto_date = this.resultData.lotto_date
          this.lotto.round = this.resultData.round
          this.lotto.show_result = this.resultData.show_result
          this.lotto.results = this.resultData.results
          console.log('this.lotto.results', this.lotto.results)
        } else {
          this.$router.push({ name: 'admin-results' })
        }
      })
    },
    save(data) {
      LottoService.updateResult({
        lottoType: this.$route.params.lottoType,
        lottoId: this.$route.params.resultId
      }, data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-lotto-results', params: { lottoType: data.lotto_type } })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {
    this.loadResult()
  }
}

</script>
